export const AUDIO_TEST_TIMEOUT = 30000
export const VOLUME_TEST_TIMEOUT = 4000
export const TIMEOUT_BEFORE_REDIRECT = 5000
export const MIN_BANDWIDTH_MB = 0.25
export const AUDIO_LEVEL_THRESHOLD = 200
export const CAMERA = 'camera'
export const MICROPHONE = 'microphone'
export const BANDWIDTH = 'bandwidth'
export const TESTING = 'testing'
export const SUCCESS = 'success'
export const FAIL = 'fail'
export const DEFAULT = 'default'
export const VIDEO = 'video'
export const AUDIO = 'audio'
export const SPEED = 'speed'
